import { render, staticRenderFns } from "./inform.vue?vue&type=template&id=331560ac&scoped=true&"
import script from "./inform.vue?vue&type=script&lang=js&"
export * from "./inform.vue?vue&type=script&lang=js&"
import style0 from "./inform.vue?vue&type=style&index=0&id=331560ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331560ac",
  null
  
)

export default component.exports